import { api } from '@/services/api';
import { normalizePage, normalizePerPage } from '@/components/Search/utils';

export const CROSS_TENANT_VISUAL_SEARCH_QUERY_KEY = 'crossTenant.visualSearch';

export const queryKey = ({
  files,
  searchQuery,
  metadataFilters,
  folders,
  extensions,
  page,
  perPage,
  tenantId,
}: {
  files: File[];
  searchQuery?: string;
  metadataFilters?: string;
  folders?: string;
  extensions?: string;
  page?: string | number;
  perPage?: string | number;
  tenantId: string;
}) => [
  CROSS_TENANT_VISUAL_SEARCH_QUERY_KEY,
  {
    fileNames: files.map(f => f.name).join(','),
    fileSizes: files.map(f => f.size).join(','),
    searchQuery,
    metadataFilters,
    folders,
    extensions,
    page: `${normalizePage(page)}`,
    perPage: `${normalizePerPage(perPage)}`,
    tenantId,
  },
];

export const queryFunction =
  ({
    files,
    searchQuery,
    metadataFilters,
    folders,
    extensions,
    page,
    perPage,
    tenantId,
  }: {
    files: File[];
    searchQuery?: string;
    metadataFilters?: string;
    folders?: string;
    extensions?: string;
    page?: string | number;
    perPage?: string | number;
    tenantId: string;
  }) =>
  () =>
    api.crossTenant.visualSearch(tenantId, {
      files,
      searchQuery,
      metadataFilters,
      folders,
      extensions,
      page: `${normalizePage(page)}`,
      perPage: `${normalizePerPage(perPage)}`,
    });
